module.exports = __webpack_public_path__ + "static/media/location-maps-letter-h-arrow.dfb2e12b.png";